import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
//Material UI
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Tick from "../images/tick.svg";
import { enrollUserToClass } from "../redux/actions/dataActions";
import TickItem from "./TickItem";

import store from "../redux/store"; 

import { ENROLL_TO_CLASS } from "../redux/types.js";

const styles = {
  root: {
    minWidth: 275,
    margin: "1.5em auto 1.5em auto",
  },
};

class ProgramCard extends Component {
  enrollUserToClass = () => {

    store.dispatch({
        type: ENROLL_TO_CLASS,
        payload: this.props.program.classId 
    });

    // this.props.enrollUserToClass({ classId: this.props.program.classId }); 
    // TODO: replace classId key to programId in api
    // TODO: update UI to show a popup dialog saying that they are enrolled
    // currently it just shows scaffold of the page without rendered programs
  };

  goToProgram = () => {
    // TODO: implement a route to go to the curriculum page of the program
    this.props.enrollUserToClass({ classId: this.props.programId });
    // TODO: update UI to show a popup dialog saying that they are enrolled
  };

  render() {
    const { classes } = this.props;
    const { authenticated } = this.props.user;
    const program = this.props.program;
    // TODO: add a logic to disable <Button disabled={}/> if the user is already enrolled
    const enrollButton = authenticated ? (
      <Button
        size="small"
        color="secondary"
        onClick={this.enrollUserToClass}
        variant="contained"
      >
        Enroll
      </Button>
    ) : (
      <Fragment />
    );

    return (
      <Card className={classes.root} variant="outlined">
        <CardContent>
          <Typography variant="h4" gutterBottom>
            {program.classTitle}
          </Typography>
          {/* TODO: all these fields are not populated yet! */}
          <Typography variant="body1">
            <b>Begins: </b>
            {program.classStartDate}
            <br />
            <b>Ends: </b>
            {program.classEndDate}
          </Typography>
          <hr style={{ backgroundColor: "#63a3e5" }} />
          <Typography variant="body1">
            <b>This is for you if</b>
            <br />
            {program.classDescription}
            <br />
            <br />
            <b>What you'll learn</b>
            <br />
          </Typography>
          {/* TODO: abstract this one based on the return value of program summary */}
          {program.classLearnings.map((learning) => <TickItem image={Tick} text={learning}/>)}
        </CardContent>
        <CardActions>{enrollButton}</CardActions>
      </Card>
    );
  }
}

ProgramCard.propTypes = {
  program: PropTypes.object.isRequired,
  enrollUserToClass: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
});

const mapActionsToProps = {
  enrollUserToClass,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(ProgramCard));
